import React, { useEffect, useCallback } from 'react'
import { useAuth } from './auth'
import { Routes, useLocation, useNavigate } from 'react-router-dom'
import { createBrowserHistory } from 'history'

const routes = Object.freeze({
	projects: '/',
	dashboard: '/dashboard',
	projectDetail: '/papers/:id',
	emailTemplates: '/email-templates',
	emailTemplatesCreate: '/email-templates/new',
	emailTemplatesDetail: '/email-templates/:id',
	clients: '/clients',
	accounts: '/accounts',
	signin: '/accounts/signin',
	callback: '/oauth/callback',
	confirm: '/oauth/confirm',
})

export const PrivateRoutes = ({ children, location }) => {
	let loc = useLocation()
	const auth = useAuth()
	const navigate = useNavigate()

	const redirect = useCallback(() => {
		navigate(routes.signin, { state: { from: loc } })
	}, [navigate, loc])

    const verifyToken = useCallback(async () => {
	    if ([routes.confirm, routes.callback, routes.signin].includes(loc.pathname)) {
          return
        }

        if (!auth.isAuthenticated) {
          redirect()
          return
        }

		try {
          const ok = await auth.verify()
          if (!ok) {
            redirect()
          }
        } catch (err) {
          if (err.response?.status === 401) {
            try {
              await auth.refresh()
            } catch {
              redirect()
            }
          } else {
            redirect()
          }
        }
	}, [auth, loc.pathname, redirect])

    useEffect(() => {
	  verifyToken()
    }, [])
	return <Routes children={children} location={location} />
}

export const history = createBrowserHistory()

export default routes
